// extracted by mini-css-extract-plugin
export default {"page_content":"style_page_content__yJ4Zw","title":"style_title__6Mw4q"};